import Alert from 'react-bootstrap/Alert';
import "../../api/Api" 

function Card(props) {
    
    return (
        <Alert show={props.show} variant={props.variant}>
            <Alert.Heading>{props.heading}</Alert.Heading>
            <p>{props.message}</p>
        </Alert>
    );
}
export default Card;